// extracted by mini-css-extract-plugin
export var active = "_2m-j";
export var cell = "_2m-3";
export var cellLoading = "_2m-6";
export var center = "_2m-10";
export var clickable = "_2m-c";
export var compact = "_2m-4";
export var container = "_2m-8";
export var data = "_2m-a";
export var dataRow = "_2m-b";
export var dateRangeContainer = "_2m-2";
export var downloadIcon = "_2m-v";
export var empty = "_2m-e";
export var filter = "_2m-g";
export var filterContainer = "_2m-16";
export var filterCount = "_2m-i";
export var filterLabel = "_2m-h";
export var filters = "_2m-f";
export var header = "_2m-l";
export var headerButton = "_2m-m";
export var headerContent = "_2m-n";
export var headerLabel = "_2m-p";
export var headerRow = "_2m-u";
export var headerSort = "_2m-o";
export var headerSortAsc = "_2m-r";
export var headerSortContainer = "_2m-q";
export var headerSortDesc = "_2m-s";
export var headerSpacer = "_2m-t";
export var headers = "_2m-w";
export var infoIcon = "_2m-1b";
export var left = "_2m-z";
export var loader = "_2m-y";
export var loaderContainer = "_2m-x";
export var main = "_2m-9";
export var movingGradient = "_2m-7";
export var options = "_2m-0";
export var pageChangeButton = "_2m-1a";
export var pageControl = "_2m-17";
export var pageControlSticky = "_2m-18";
export var pageNumbers = "_2m-19";
export var right = "_2m-11";
export var seamless = "_2m-1";
export var spacer = "_2m-12";
export var table = "_2m-14";
export var tableContainer = "_2m-13";
export var tableFitToParent = "_2m-15";
export var textHeader = "_2m-k";
export var title = "_2m-d";
export var wide = "_2m-5";